<template>
  <Panel
    class="scores d-flex align-items-center justify-content-around p-0"
    :variant="scoresVariant"
  >
    <div
      v-if="editMode"
      class="d-flex flex-column justify-content-center align-items-center mx-5"
    >
      <TextBlock
        :variant="'muted'"
        :text="$$t('Rank')"
        size="1.2"
        class="m-3"
      />
      <input
        v-model.number="score.rank"
        class="scores_input hide-arrows"
        type="number"
        :maxlength="inputMaxLength"
        oninput="this.value=this.value.slice(0,this.maxLength)"
        @input="$emit('update', score)"
      />
    </div>

    <div
      v-else
      class="d-flex flex-column justify-content-center align-items-center mx-5"
    >
      <TextBlock
        :variant="'muted'"
        :text="$$t('Rank')"
        size="1.2"
        class="m-3"
      /><span
        class="scores_item mx-1"
        :class="{
          'text-secondary': !hasValue(score.rank),
        }"
        >{{ hasValue(score.rank) || defaultValues[0] }}</span
      >
    </div>

    <template>
      <div
        v-if="editMode"
        class="d-flex flex-column justify-content-center align-items-center mx-5"
      >
        <TextBlock
          :variant="'muted'"
          :text="$$t('Kills')"
          size="1.2"
          class="m-3"
        />
        <input
          v-if="editMode"
          v-model.number="score.kill_count"
          class="scores_input hide-arrows"
          type="number"
          :maxlength="inputMaxLength"
          oninput="this.value=this.value.slice(0,this.maxLength)"
          @input="$emit('update', score)"
        />
      </div>
      <div
        v-else
        class="d-flex flex-column justify-content-center align-items-center mx-5"
      >
        <TextBlock
          :variant="'muted'"
          :text="$$t('Kills')"
          size="1.2"
          class="m-3"
        />
        <span
          class="scores_item mx-1"
          :class="{
            'text-secondary': !hasValue(score.kill_count),
          }"
          >{{ hasValue(score.kill_count) || defaultValues[1] }}</span
        >
      </div>
    </template>
  </Panel>
</template>
<script>
import Panel from '@/components/atoms/Panel';
import TextBlock from '@/components/atoms/TextBlock.vue';
import { translate } from '@/mixins/translate';
export default {
  name: 'RoyaleScores',
  components: {
    Panel,
    TextBlock,
  },
  mixins: [translate('_web_account_battle_info_card')],
  model: {
    event: 'update',
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    inputMaxLength: {
      type: Number,
      default: 2,
    },
    defaultValues: {
      type: Array,
      default: () => ['', ''],
    },
  },
  computed: {
    score() {
      return this.value;
    },
    scoresVariant() {
      const strokeVariant = this.errors.length
        ? ['stroked', 'stroked-error']
        : ['stroked', 'stroked-secondary'];
      return ['transparent', 'rounded-medium', ...strokeVariant];
    },
  },
  methods: {
    hasValue(score) {
      // check the "0" value = is also result (not false)
      return Number.isInteger(score) || score === 'Win' || score === 'Lose'
        ? score.toString()
        : false;
    },
  },
};
</script>
<style lang="scss">
.scores {
  .scores_item,
  input[type='number'] {
    height: 28px;
    width: 38px;
    padding: 5px;
    border: none;
    text-align: center;
    background-color: transparent;
    color: white;
    outline: none;
  }

  &.editable {
    display: block;
    background-color: transparent;
    overflow: hidden;
  }
  &_item {
    line-height: 1.2;
    .error & {
      color: $ph-error;
    }
  }
  .bold & {
    font-weight: 500;
  }
  .lh-30 {
    line-height: 30px;
  }
  &:focus-within {
    border-color: $ph-accent !important;
  }
}
</style>
